import React, { useCallback } from 'react';
import { NextPage } from 'next';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { BlogPostsResponse } from './blogPosts';
import { BlogBase } from './BlogBase';
import { BlogPostListItemView } from './BlogPostListItemView';
import { BlogUpselling } from './BlogUpselling';
import { BlogPagination } from './BlogPagination';
import style from './BlogPostsPage.module.scss';

const { pageTitle } = defineMessages({
  pageTitle: {
    id: 'web.blog.page_title',
    defaultMessage: 'Blog'
  }
});

export interface BlogPostsPage {
  blogPosts: BlogPostsResponse;
  limit: number;
  currentPage: number;
}

export const BlogPostsPage: NextPage<BlogPostsPage> = React.memo(({ blogPosts: { meta, data }, currentPage }) => {
  const intl = useIntl();

  const getPaginationURL = useCallback((page: number) => {
    const pathName = '/blog';
    let as = `/blog`;
    if (page) {
      as += `?page=${page}`;
    }
    return {
      href: {
        pathname: pathName,
        query: { page }
      },
      as
    };
  }, []);

  return (
    <BlogBase
      pageTitle={
        currentPage
          ? `${intl.formatMessage(
              {
                id: 'web.page_string',
                defaultMessage: 'Page {number} of'
              },
              { number: currentPage + 1 }
            )} ${intl.formatMessage(pageTitle)}`
          : intl.formatMessage(pageTitle)
      }
    >
      <Container>
        <div className={style.page}>
          <div className={style.entryList}>
            {data.map((blogPost) => (
              <BlogPostListItemView key={blogPost.attributes.slug} post={blogPost} />
            ))}
          </div>
          <div className="px-2 px-md-5">
            <BlogPagination
              total={meta.pagination.total}
              limit={meta.pagination.pageSize}
              page={currentPage}
              getURL={getPaginationURL}
            />
          </div>
        </div>
      </Container>
      <BlogUpselling />
    </BlogBase>
  );
});
